import React from 'react';
// コンポーネント
import { SubTitle } from 'components/uiParts/SubTitle';
import { UpdateClientForm } from 'components/uiParts/Form/UpdateClientForm';
import { Breadcrumb } from 'components/uiParts/Breadcrumb';
// カスタムフック
import { useGetDetailId } from 'hooks/useGetDetailId';
// 定数ファイル
import { CLIENT_FORM_COLUMNS } from 'utils/constantsTable';
// MUI
import Button from '@mui/material/Button';

export const ClientDetailPage = () => {
  // カスタムフック
  const { id } = useGetDetailId();

  const breadcrumbList = [
    { name: 'ダッシュボード', href: '/' },
    { name: '顧客一覧', href: '/client/list' },
    { name: '顧客詳細' },
  ];

  return (
    <>
      <Breadcrumb breadcrumbList={breadcrumbList} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <SubTitle title='顧客詳細' />
        <Button href={location.origin + '/client/list'} variant='contained' color='inherit'>
          戻る
        </Button>
      </div>
      <UpdateClientForm api='Client' params={[{ id: id }]} columns={CLIENT_FORM_COLUMNS} />
    </>
  );
};

// 顧客一覧
// 顧客登録
// まとめて登録は無し
// 顧客詳細
// 変更を反映したら一覧に戻る
// ハウス登録は無し
